import {
  keepPreviousData,
  queryOptions,
  skipToken,
} from '@tanstack/react-query';

import type {
  BookingSpecialistAvailabilityQueryParams,
  BookingSpecialistAvailabilityResponse,
} from '@/types/api/queries';

import { HttpClient } from '@/network/HttpClient';

export const bookingSpecialistAvailabilityKeys = {
  all: () => ['bookingSpecialistAvailability'] as const,
  slots: (props: BookingSpecialistAvailabilityQueryParams) =>
    [
      ...bookingSpecialistAvailabilityKeys.all(),
      'slots',
      props.url,
      props.locationId,
      props.staffId,
      props.serviceId,
      props.bookingType,
      props.date,
      props.reservationId,
    ] as const,
};

export const bookingSpecialistAvailabilityQueries = {
  slots: (props: BookingSpecialistAvailabilityQueryParams) => {
    const {
      url,
      locationId,
      staffId,
      serviceId,
      bookingType,
      date,
      reservationId,
    } = props;

    return queryOptions({
      queryKey: bookingSpecialistAvailabilityKeys.slots(props),
      queryFn:
        url && locationId && staffId && serviceId && date
          ? () =>
              HttpClient.request<BookingSpecialistAvailabilityResponse>({
                method: 'GET',
                url,
                params: {
                  location_id: locationId,
                  staff_id: staffId,
                  service_id: serviceId,
                  booking_type: bookingType,
                  date,
                  reservation_id: reservationId,
                },
              })
          : skipToken,
      placeholderData: keepPreviousData,
      refetchOnWindowFocus: false,
    });
  },
};
